const NODE_ENV = process.env.NODE_ENV || "development";

//#region Oim Canlı
let localPath = "https://oim.igdas.com.tr";
let servicePath = "https://oimapi.igdas.com.tr";
let askidaFaturaErrorFormUrl ="https://askidafatura.ibb.gov.tr/invoce-process";
let askidaFaturaResultUrl ="https://oimapi.igdas.com.tr/paymentgateway/IbbPaymentResult.aspx";
let masterpassTestService ="https://ui.masterpassturkiye.com/v2";
let masterpassProvisionUrl="https://oimapi.igdas.com.tr/paymentgateway/MasterpassProvision.aspx?igdas_order_mp=";
let kfsUrl="https://oim.igdas.com.tr/KFS/Enduser/Login"; 
// //#endregion

// //#region Testoim
// let localPath = "https://testoim.igdas.com.tr";
// let servicePath = "https://oimapiq.igdas.com.tr";
// let askidaFaturaErrorFormUrl ="https://askidafaturatest.ibb.gov.tr/invoce-process";
// let askidaFaturaResultUrl ="https://oimapiq.igdas.com.tr/paymentgateway/IbbPaymentResult.aspx";
// let masterpassTestService ="https://test.masterpassturkiye.com/MasterpassJsonServerHandler/v2";
// let masterpassProvisionUrl="https://oimapiq.igdas.com.tr/paymentgateway/MasterpassProvision.aspx?igdas_order_mp=";
// let kfsUrl="https://testoim.igdas.com.tr/KFS/Enduser/Login";
// //#endregion

// #region TestoimS4
// let localPath = "https://testoims4.igdas.com.tr";
// let servicePath = "https://oimapiqs4.igdas.com.tr";
// let askidaFaturaErrorFormUrl ="https://askidafaturatest.ibb.gov.tr/invoce-process";
// let askidaFaturaResultUrl ="https://oimapiqs4.igdas.com.tr/paymentgateway/IbbPaymentResult.aspx";
// let masterpassTestService ="https://test.masterpassturkiye.com/MasterpassJsonServerHandler/v2";
// let masterpassProvisionUrl="https://oimapiqs4.igdas.com.tr/paymentgateway/MasterpassProvision.aspx?igdas_order_mp=";
// let kfsUrl="https://testoims4.igdas.com.tr/KFS/Enduser/Login";
// #endregion

//#region Testoim2
// let localPath = "https://testoim2.igdas.com.tr";
// let servicePath = "https://oimapiq2.igdas.com.tr";
// let askidaFaturaErrorFormUrl ="https://askidafaturatest.ibb.gov.tr/invoce-process";
// let askidaFaturaResultUrl ="https://oimapiq2.igdas.com.tr/paymentgateway/IbbPaymentResult.aspx";
// let masterpassTestService ="https://test.masterpassturkiye.com/MasterpassJsonServerHandler/v2";
// let masterpassProvisionUrl ="https://oimapiq2.igdas.com.tr/paymentgateway/MasterpassProvision.aspx?igdas_order_mp=";
// let kfsUrl="https://testoim.igdas.com.tr/KFS/Enduser/Login";
//#endregion

//#region Oim2
// let localPath = "https://oim2.igdas.com.tr";
// let servicePath = "https://oimapi2.igdas.com.tr";
// let askidaFaturaErrorFormUrl ="https://askidafaturatest.ibb.gov.tr/invoce-process";
// let askidaFaturaResultUrl ="https://oimapi2.igdas.com.tr/paymentgateway/IbbPaymentResult.aspx";
// let masterpassTestService ="https://ui.masterpassturkiye.com/v2";
// let masterpassProvisionUrl ="https://oimapi2.igdas.com.tr/paymentgateway/MasterpassProvision.aspx?igdas_order_mp=";
// let kfsUrl="https://internetsubesi.igdas.istanbul/KFS/Enduser/Login";
//#endregion


let paymentFormPath = `${servicePath}/paymentgateway/Payment.aspx`;
if (NODE_ENV === "development") {
  localPath = "http://localhost:3000";
  servicePath = "http://localhost:52795";
  paymentFormPath = 'http://localhost:56255/Payment.aspx';
  askidaFaturaResultUrl = "http://localhost:56255/IbbPaymentResult.aspx";
  // masterpassTestService="https://ui.masterpassturkiye.com/v2";
  // masterpassTestService ="https://ui.masterpassturkiye.com/v2";
  masterpassProvisionUrl="http://localhost:56255/MasterpassProvision.aspx?igdas_order_mp=";
  kfsUrl="https://testoim.igdas.com.tr/KFS/Enduser/Login"
} 

module.exports = {
  /** The environment to use when building the project */ // test // online randevu
  env: NODE_ENV,
  /** The full path to the project's root directory */
  basePath: __dirname,
  /** The name of the directory containing the application source code */
  srcDir: "src",
  /** The file name of the application's entry point */
  main: "main",
  /** The name of the directory in which to emit compiled assets */
  outDir: "dist",
  /** The base path for all projects assets (relative to the website root) */
  publicPath: "/",
  /** Whether to generate sourcemaps */
  sourcemaps: true,
  /** A hash map of keys that the compiler should treat as external to the project */
  externals: {},
  /** A hash map of variables and their values to expose globally */
  globals: {},
  /** Whether to enable verbose logging */
  verbose: false,
  /** The list of modules to bundle separately from the core application code */
  vendors: [
    "react",
    "react-dom",
    "redux",
    "react-redux",
    "redux-thunk",
    "react-router",
  ],
  localPath: localPath,
  servicePath: servicePath,
  paymentFormPath: paymentFormPath,
  askidaFaturaResultUrl: askidaFaturaResultUrl,
  askidaFaturaErrorFormUrl: askidaFaturaErrorFormUrl,
  masterpassTestService:masterpassTestService,
  masterpassProvisionUrl:masterpassProvisionUrl,
  kfsUrl:kfsUrl
};



// WEBPACK FOOTER //
// ./project.config.js